





































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import TaskApi from '@/api/task'

@Component({
	name: 'exceptionList',
	components: {
		PageLayout,
	},
})
export default class exceptionList extends Mixins(listMixins) {
	private data: any[] = []
	private exportingList: boolean = false
	// 完成时间、订单号、异常类型（签字异常、回访异常）、异常次数、作业人员姓名、伤者电话、签字电话、查看（签字异常点击进入订单原来详情、回访异常点击进入回访详情）
	private columns: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'key',
		},
		{
			title: '完成时间',
			align: 'center',
			dataIndex: 'finishTime',
			scopedSlots: { customRender: 'finishTime' },
		},
		{
			title: '订单号',
			align: 'center',
			dataIndex: 'orderNo',
		},
		{
			title: '异常类型',
			align: 'center',
			dataIndex: 'exceptionType',
			scopedSlots: { customRender: 'exceptionType' },
		},
		{
			title: '异常次数',
			align: 'center',
			dataIndex: 'exceptionCount',
		},
		{
			title: '作业人员姓名',
			align: 'center',
			dataIndex: 'name',
		},
		{
			title: '伤者电话',
			align: 'center',
			dataIndex: 'injuredPhone',
		},
		{
			title: '签字电话',
			align: 'center',
			dataIndex: 'signaturePhone',
		},
		{
			title: '操作',
			align: 'center',
			key: 'operation',
			scopedSlots: { customRender: 'operation' },
		},
	]

	private exportList() {
		this.exportingList = true
		TaskApi.exportException(this.getForm())
			.then((file: any) => {
				download(file.data, file.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private getForm() {
		let form: any = this.getSearchValues()
		if (form.finishTime) {
			form.finishStartTime =
				form.finishTime &&
				form.finishTime[0] &&
				form.finishTime[0].format('YYYY-MM-DD')
			form.finishEndTime =
				form.finishTime &&
				form.finishTime[1] &&
				form.finishTime[1].format('YYYY-MM-DD')
		}
		delete form.finishTime

		let companyId = form.company && form.company.value
		if (companyId && companyId.trim()) {
			form.companyId = companyId
		}
		delete form.company

		return form
	}

	private goToDetail(row: any) {
		if (row.exceptionType === '0') {
			// 人伤任务详情
			return `/AiiTasks/TasksDetail/${row.orderId}/${row.taskType}`
		} else if (row.exceptionType === '1') {
			// 回访详情
			return `/returnVisit/tasksDetail/${row.revisitorId}`
		}
	}

	public getList() {
		return TaskApi.getExceptionList(this.getForm()).then((res: any) => {
			this.data = res.data.retList.map((item: any, index: number) => {
				let key = index + 1 + (this.current - 1) * this.pageSize
				return Object.assign({}, item, { key })
			})
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.$store.dispatch('setting/initAreas')
		this.getList()
	}
}
